
    import ContactTypeView from "@/components/contactType/ContactTypeView.vue";
    import ContactTypeIndex from "@/components/contactType/ContactTypeIndex.vue";
    import ContactTypeEdit from "@/components/contactType/ContactTypeEdit.vue";
    import ContactTypeCreate from "@/components/contactType/ContactTypeCreate.vue";
    // import { Role } from "@/router/_helper";

    const contactType = {
      path: "/contactType",
      name: "contactType",
      component: ContactTypeIndex,
      children: [
        { path: "view/:id", component: ContactTypeView , name: "contactTypeView" },
        { path: "edit/:id", component: ContactTypeEdit , name: "contactTypeEdit" },
        { path: "create", component: ContactTypeCreate , name: "contactTypeCreate"}
      ],
      meta: { authorize: [], requiresAuth: true }
    };

    export default contactType;
    